import * as Util from './util.js';

class Topics
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Topics
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //参照
    const holder = this;
    this.topics = $(".p-top__fvTopics");
    this.title = $(".p-top__fvTopics-title");
    this.slide = $(".p-top__fvTopics-slide");
    this.pager = $(".p-top__fvTopics-pager");

    //変数初期化
    this.pageIndex = -1;

    //座標配列
    this.prevTouches = [];

    //ロック用フラグ
    this.isLock = false;

    //改行対応
    $(".p-top__fvTopics-info .title").each(function(index){
      holder.initMultiline($(this));
    });
    $(".p-top__fvTopics-info .subtitle").each(function(index){
      holder.initMultiline($(this));
    });

    //タイトル初期化
    $(".animation-title").each(function(index){
      $(this).append("<div class='base'></div>");
      $(this).append("<div class='cover'></div>");
    });

    //スライドの初期化
    this.pages = [];
    this.slide.find(">li").each(function(index){
      const page = $(this);
      holder.pages.push(page);
      holder.initPage(page);
    });

    //ページの総数を保持
    this.totalPageNum = this.pages.length;

    //ページャー追加
    for(let i=0; i<this.totalPageNum; i++)
    {
      this.pager.append("<li><span></span></li>");
    }
    TweenMax.set(this.pager, {alpha:0});
    this.resetPager();

    //ページャーのアクション
    this.pager.find(">li").each(function(index){
      $(this).on("click", function(e){
        holder.changePage(index);
      });
    });

    //タッチのハンドリング
    this.topics.on("touchstart", this.onTouchStart.bind(this));

    //リサイズのハンドリング
    $(window).on('resize', this.onResize.bind(this));
    this.onResize();
  }

  /**
   * 複数行の初期化処理
   * @return {[type]} [description]
   */
  initMultiline(titleContainer)
  {
    const span = titleContainer.find(">p >span");
    const html = span.html();
    if(html.indexOf("<br>") >= 0)
    {
      titleContainer.empty();
      const lines = html.split("<br>");
      for(let i=0; i<lines.length; i++)
      {
        titleContainer.append('<p class="animation-title"><span>' + lines[i] + '</span></p>');
      }
    }
  }

  /**
   * スタート
   */
  start()
  {
    //タイトル表示
    this.title.addClass("show");

    //次のページへ
    this.nextPage();

    //ページャー表示
    TweenMax.to(this.pager, 0.5, {alpha:1, delay:0.6, ease:Power0.easeNone});
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	ページコントロール関連
	// ---------------------------------------------------------------------------------------------------------

  /**
   * 次のページへ
   */
  nextPage(dir = 1){

    let nextPageIndex = this.pageIndex + dir;
    if(nextPageIndex >= this.totalPageNum) nextPageIndex = 0;
    if(nextPageIndex < 0) nextPageIndex = this.totalPageNum - 1;

    this.changePage(nextPageIndex);
  }

  /**
   * ページ変更
   * @type {[type]}
   */
  changePage(nextPageIndex){

    //同じページなら処理しない
    if(nextPageIndex == this.pageIndex) return;

    //ロック
    if(this.isLock) return;
    this.isLock = true;

    //ページャーのアニメーション停止
    this.stopPager();

    //変数初期化
    let delay = 0;

    //前のページの情報を消す
    if(this.pageIndex >= 0)
    {
      delay = 0.3;
      const prePage = this.pages[this.pageIndex];
      this.hidePage(prePage);
    }

    //次のページ表示
    TweenMax.delayedCall(delay, ()=>{

      //ページインデックス更新
      this.pageIndex = nextPageIndex;

      //ページャーリセット
      this.resetPager();

      //次のページ表示
      this.showPage(this.pages[this.pageIndex]);

      //ページャーアニメーション
      const currentPager = this.pager.find("span").eq(this.pageIndex);
      TweenMax.killTweensOf(currentPager);
      TweenMax.to(currentPager, 8, {"width":"100%", ease:Power0.easeNone, onComplete:this.nextPage.bind(this)});
    })
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	ページ関連
	// ---------------------------------------------------------------------------------------------------------

  /**
   * ページ初期化
   */
  initPage(page){

    //画像を背景画像に差し替え
    const img = page.find("img");
    const path = img.attr("src");
    img.remove();
    const imgContainer = page.find(".img-container");
    let span = $("<span></span>");
    span.css("background-image", "url(" + path + ")");
    span.css("width", this.topics.width() + "px");
    imgContainer.append(span);

    //画像にマスクをかける
    TweenMax.set(imgContainer, {width:"0%"});
  }

  /**
   * ページ表示
   */
  showPage(page){

    //ページを最前面に移動
    page.remove();
    this.slide.append(page);

    //イメージのマスクイン
    const imgContainer = page.find(".img-container");
    TweenMax.to(imgContainer, 0.8, {width:"100%", ease:Quint.easeInOut});

    //各要素を参照
    const info = page.find(".p-top__fvTopics-info");
    const title = info.find(".title >p");
    const subtitle = info.find(".subtitle >p");
    const moreBtn = info.find(".more-btn");

    //タイトル
    TweenMax.delayedCall(0.6, ()=>{
      title.addClass("enter");
    });
    TweenMax.delayedCall(1.2, ()=>{
      title.addClass("show");
    });

    //サブタイトル
    TweenMax.delayedCall(0.8, ()=>{
      subtitle.addClass("enter");
    });
    TweenMax.delayedCall(1.4, ()=>{
      subtitle.addClass("show");
    });

    //MOREボタン
    TweenMax.delayedCall(1.0, ()=>{
      moreBtn.addClass("enter");
    });
    TweenMax.delayedCall(1.6, ()=>{
      moreBtn.addClass("show");
    });

    //ロック解除
    TweenMax.delayedCall(1.5, ()=>{
      this.isLock = false;
    });
  }

  /**
   * ページを隠す
   */
  hidePage(page){

    //各要素を参照
    const info = page.find(".p-top__fvTopics-info");
    const title = info.find(".title >p");
    const subtitle = info.find(".subtitle >p");
    const moreBtn = info.find(".more-btn");
    const imgContainer = page.find(".img-container");

    //アニメーション
    title.removeClass("enter");
    title.removeClass("show");
    subtitle.removeClass("enter");
    subtitle.removeClass("show");
    moreBtn.removeClass("enter");
    moreBtn.removeClass("show");

    //リセット
    TweenMax.delayedCall(1.0, ()=>{
      TweenMax.set(imgContainer, {width:"0%"});
    });
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	ページャー関連
	// ---------------------------------------------------------------------------------------------------------

  stopPager(){
    this.pager.find("span").each(function(index){
      TweenMax.killTweensOf($(this));
    });
  }

  resetPager(){
    const holder = this;
    this.pager.find("span").each(function(index){
      TweenMax.killTweensOf($(this));
      if(index < holder.pageIndex)
      {
        TweenMax.set($(this), {"width":"100%"});
      }
      else
      {
        TweenMax.set($(this), {"width":"0%"});
      }
    });
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	タッチ関連
	// ---------------------------------------------------------------------------------------------------------

  onTouchStart(e){

    //座標初期化
    this.prevTouches = [event.changedTouches[0].pageX];

    //リスナー登録
    this.topics.on("touchmove", this.onTouchMove.bind(this));
    this.topics.on("touchend", this.onTouchEnd.bind(this));
  }

  onTouchMove(e){

    //座標追加
    this.prevTouches.push(event.changedTouches[0].pageX);

    //古いデータ削除
    if(this.prevTouches.length > 10) this.prevTouches.shift();
  }

  onTouchEnd(e){

    //スワイプでページ遷移
    let dir = 0;
    let len = this.prevTouches.length;
    if(len > 8)
    {
      for(let i=1; i<len; i++)
      {
        const prevX = this.prevTouches[i-1]
        const nextX = this.prevTouches[i];
        dir += (nextX - prevX);
      }

      if(Math.abs(dir) >= 50)
      {
        if(dir <= -50)
        {
          this.nextPage(1);
        }
        else if(dir >= 50)
        {
          this.nextPage(-1);
        }
      }
    }

    //リスナー削除
    this.topics.off("touchmove");
    this.topics.off("touchend");
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	リサイズ関連
	// ---------------------------------------------------------------------------------------------------------

  onResize(){

    this.updatePageSize();
  }

  /**
   * ページのサイズを更新
   */
  updatePageSize(){
    for(let i=0; i<this.pages.length; i++)
    {
      const page = this.pages[i];
      page.find(".img-container >span").css("width", this.topics.width() + "px");
    }
  }


  // ---------------------------------------------------------------------------------------------------------
}

export default Topics;
